/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  placeholder?: string;
  animated?: boolean;
  register?: any;
  prefix?: string;
  sufix?: string;
  decimal?: string;
  floats?: number;
  thousands?: string;
  errorMessage?: string;
  description?: string;
  value?: number;
  onChangeTextOut?: (v: number, valueFormat?: string) => void;
}

export function InputCurrency({
  label,
  prefix = "",
  sufix = "",
  decimal = ",",
  floats = 2,
  thousands = ".",
  placeholder,
  animated,
  register,
  errorMessage,
  description,
  value,
  onChangeTextOut,
  ...rest
}: IProps) {
  const [input, setInput] = useState("");
  const [numValue, setNumValue] = useState("0");

  function convertStringToNumber(value: string): string {
    // Remove tudo que não é número
    let digits = value.replace(/[^0-9]/g, "");

    if (!digits) {
      return "0";
    }

    // Se tem menos dígitos que casas decimais, adiciona zeros à esquerda
    if (digits.length <= floats) {
      digits = digits.padStart(floats + 1, "0");
    }

    // Separa em parte inteira e decimal
    let integerPart = digits.substring(0, digits.length - floats);
    const decimalPart = digits.substring(digits.length - floats);

    // Remove zeros à esquerda da parte inteira, mas mantém pelo menos um
    integerPart = integerPart.replace(/^0+/, "") || "0";

    return `${integerPart}.${decimalPart}`;
  }

  function applyMask(numericValue: string): string {
    // Se for zero ou vazio, limpa o input
    if (!numericValue || Number(numericValue) === 0) {
      setInput("");

      return "";
    }

    const [intPart, decimalPart] = numericValue.split(".");
    const intReverse = intPart.split("").reverse();
    const formattedInt = [];

    // Adiciona separador de milhares
    for (let i = 0; i < intReverse.length; i++) {
      formattedInt.unshift(intReverse[i]);
      if (i > 0 && (i + 1) % 3 === 0 && i + 1 < intReverse.length) {
        formattedInt.unshift(thousands);
      }
    }

    // Garante que sempre terá 'floats' casas decimais
    const finalDecimal = decimalPart
      ? decimalPart.substring(0, floats).padEnd(floats, "0")
      : "".padEnd(floats, "0");

    const formatValue = `${prefix}${prefix ? " " : ""}${formattedInt.join(
      ""
    )}${decimal}${finalDecimal}${sufix ? " " + sufix : ""}`;

    setInput(formatValue);


    return formatValue;
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const inputValue = e.target.value;
    const numeric = convertStringToNumber(inputValue);
    const formattedValue = applyMask(numeric);

    setNumValue(numeric);
    onChangeTextOut?.(Number(numeric), formattedValue);
  }

  useEffect(() => {
    if (typeof value === "number" && value !== Number(numValue)) {
      setNumValue(String(value));
    }
  }, [value]);

  useEffect(() => {
    applyMask(numValue);
  }, [numValue]);

  return (
    <>
      {animated ? (
        <div className={`form-floating mb-3`}>
          <input
            className={`form-control ${errorMessage ? "is-invalid" : ""}`}
            type="tel"
            {...register}
            {...rest}
            placeholder={
              placeholder || `${prefix}${prefix ? " " : ""}0${decimal}00`
            }
            onChange={handleChange}
            value={input}
          />
          {description && <small className="text-muted">{description}</small>}
          {errorMessage && (
            <div className="invalid-feedback">{errorMessage}</div>
          )}
          <label>{label}</label>
        </div>
      ) : (
        <div>
          {label && <label className="form-label">{label}</label>}
          <div className={`mb-3`}>
            <input
              className={`form-control ${errorMessage ? "is-invalid" : ""}`}
              type="tel"
              {...register}
              {...rest}
              placeholder={
                placeholder || `${prefix}${prefix ? " " : ""}0${decimal}00`
              }
              onChange={handleChange}
              value={input}
            />
            {description && <small className="text-muted">{description}</small>}
            {errorMessage && (
              <div className="invalid-feedback">{errorMessage}</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
